import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'shared/guards/login.guard';
import {ManagementLevelComponent} from './management-level.component';

const routes: Routes = [
  {path: 'targetgroups/managementlevel', component: ManagementLevelComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class ManagementLevelRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/management-level/management-level-routing.module.ts